import {
  BarChart,
  ResponsiveContainer,
  Tooltip,
  Bar,
  XAxis,
  YAxis,
} from "recharts";
import { Box, Typography } from "@mui/material";
import { BarChartData } from "../../data/DashBoardData";
import React, { useEffect, useState } from "react";

const BarChartComp = () => {
  const [subPerMonth, setSubPerMonth] = useState({});

  useEffect(() => {
    fetch("http://localhost:8000/admins/subscriber-per-month")
      .then((response) => response.json())
      .then((data) => setSubPerMonth(data));
  }, []);
  return (
    <Box m="1vw">
      <Typography
        variant="h6"
        color="var(--white)"
        fontWeight={600}
        paddingBottom={3}
      >
        Subscriber per Month
      </Typography>
      <Box display="flex" width="100%">
        <Box width="90%">
          <ResponsiveContainer width="99%" height={210}>
            <BarChart data={subPerMonth.chartData}>
              <XAxis
                dataKey="name"
                tick={{ fill: "white" }}
                axisLine={{ stroke: "white" }}
              />
              <YAxis tick={{ fill: "white" }} axisLine={{ stroke: "white" }} />
              <Tooltip
                contentStyle={{
                  background: "#2a3447",
                  borderRadius: "5px",
                  color: "white",
                }}
                labelStyle={{ display: "none" }}
                cursor={{ fill: "none" }}
              />
              <Bar dataKey={BarChartData.dataKey} fill={BarChartData.color} />
            </BarChart>
          </ResponsiveContainer>
        </Box>
      </Box>
    </Box>
  );
};

export default BarChartComp;
